import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CampaignNames } from '@/api/routes/campaigns/types';

import { fetchCampaignNames, fetchCampaignStaticNames } from './actionCreators';

interface InitialState {
  names: CampaignNames,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  names: [],
  isLoading: false,
  error: '',
};

export const namesSlice = createSlice({
  name: 'names',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCampaignNames.fulfilled.type]: (state, action: PayloadAction<CampaignNames>) => {
      state.isLoading = false;
      state.error = '';
      state.names = action.payload;
    },
    [fetchCampaignNames.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCampaignNames.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    [fetchCampaignStaticNames.fulfilled.type]: (state, action: PayloadAction<CampaignNames>) => {
      state.isLoading = false;
      state.error = '';
      state.names = action.payload;
    },
    [fetchCampaignStaticNames.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCampaignStaticNames.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default namesSlice.reducer;
